<template>
  <div class="animated fadeIn">
    <b-card header="변경 요청 심사 > 목록">
      <b-select v-model="gameStatusSelected" :options="gameStatusOptions" class="d-inline-block" style="width: 200px;"></b-select>
      <b-form-input id="game" v-model="search" placeholder="게임명을 입력해주세요." class="d-inline-block ml-2" style="width: 250px;"></b-form-input>
      <b-table class="mt-3" hover striped bordered small fixed responsive="sm" :items="filteredList" :fields="fields" :current-page="currentPage" :per-page="perPage" :show-empty=true empty-text="리스트가 없습니다.">
        <template slot="modTime" slot-scope="data">
          {{ data.item.modTime.format('YYYY-MM-DD HH:mm') }}
        </template>
        <template slot="aosAppStartTime" slot-scope="data">
          {{ data.item.aos.appStartTime.format('YYYY-MM-DD HH:mm') }}
        </template>
        <template slot="iosAppStartTime" slot-scope="data">
          {{ data.item.ios.appStartTime.format('YYYY-MM-DD HH:mm') }}
        </template>
        <template slot="modStatusTime" slot-scope="data">
          {{ data.item.modStatusTime.format('YYYY-MM-DD HH:mm') }}
        </template>
        <template slot="status" slot-scope="data">
          {{ GAME_STATUS[data.item.status] ? GAME_STATUS[data.item.status].text : 'unknown'}}
        </template>
        <template slot="view" slot-scope="data">
          <span class="link" v-if="data.item.status === 'requested' || data.item.status === 'rejected' ">
            <b-link :to="{name: 'gameReviewChangeRequestDetail', params: { appMasterId: data.item.appMasterId}}" class="">view</b-link>
          </span>
          <span class="link" v-if="data.item.status === 'requested' && !isInhouseLogin()">
            <b-link @click="cancelUpdateRequest(data.item)">요청취소</b-link>
          </span>
        </template>
      </b-table>
      <nav>
        <b-pagination :total-rows="this.filteredList.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
      </nav>
    </b-card>
  </div>
</template>
<script>
  import { MODULE_NAME as PGM_MODULE, FETCH_CHANGE_REQUEST_LIST } from '@/store/playGame/actions.type'
  import { $isInhouseLogin, $showModalWithErrorMsg } from '@/common/util'
  import {
    MODULE_NAME as AUTH_MODULE } from '@/store/auth/actions.type'
  import { mapGetters, mapState, mapMutations } from 'vuex'
  import { GAME_STATUS, TABLE_CLASS_WITH_ELLIPSIS, TABLE_DATE_CLASS } from '@/constants'
  import playGameService from '@/common/api/playGame.service'
  import {
    SHOW_MODAL } from '@/store/ui/mutations.type'
  export default {
    data () {
      return {
        search: '',
        currentPage: 1,
        perPage: 6,
        sortBy: 'modStatusTime',
        fields: [
          {key: 'modTime', label: '요청일자', class: TABLE_CLASS_WITH_ELLIPSIS + TABLE_DATE_CLASS},
          {key: 'appNameInfo.ko', label: '게임명 (ko)', thStyle: {width: '180px', textAlign: 'center'}, class: 'text-center'},
          {key: 'appMasterId', label: '앱 마스터 ID', class: TABLE_CLASS_WITH_ELLIPSIS, thStyle: {width: '80px'}},
          {key: 'gameViewInfo.partnerName.ko', label: '제작사 (ko)', class: TABLE_CLASS_WITH_ELLIPSIS},
          {key: 'status', label: '심사상태', class: TABLE_CLASS_WITH_ELLIPSIS, thStyle: {width: '110px'}},
          {key: 'modStatusTime', label: '승인/반려일', class: TABLE_CLASS_WITH_ELLIPSIS + TABLE_DATE_CLASS},
          {key: 'modStatusUserId', label: '승인자', class: TABLE_CLASS_WITH_ELLIPSIS, thStyle: {width: '150px'}},
          {key: 'view', label: '관리', class: TABLE_CLASS_WITH_ELLIPSIS, thStyle: {width: '200px'}}
        ],
        isInhouseLogin: $isInhouseLogin.bind(this),
        GAME_STATUS: GAME_STATUS,
        gameStatusSelected: 'all'
      }
    },
    mounted () {
      this.$store.dispatch(PGM_MODULE + FETCH_CHANGE_REQUEST_LIST)
        .catch($showModalWithErrorMsg.bind(this))
    },
    computed: {
      filteredList () {
        return this.changeRequestListWithMoment.filter((elem) => {
          if (this.gameStatusSelected !== 'all' && this.gameStatusSelected !== elem.status) {
            return false
          }

          for (let lang in elem.appNameInfo) {
            if (elem.appNameInfo[lang] != null && elem.appNameInfo[lang].includes(this.search)) {
              return true
            }
          }
          return false
        })
      },
      gameStatusOptions () {
        var arr = [
          { value: 'all',
            text: '승인상태 전체'
          }]
        for (let key in GAME_STATUS) {
          arr.push({
            value: key,
            text: GAME_STATUS[key].text
          })
        }
        return arr
      },
    ...mapState(AUTH_MODULE, [
        'auth'
      ]),
    ...mapGetters(PGM_MODULE, [
        'changeRequestListWithMoment'
      ])
    },
    methods: {
      cancelUpdateRequest (item) {
        const canceled = 'canceled'
        playGameService.updateChangeRequests({
            appMasterId: item.appMasterId,
            revNo: item.revNo,
            status: canceled
          })
          .then(()=>{
            console.log(this[SHOW_MODAL])
            this[SHOW_MODAL]({msg: '취소하였습니다.', okHandling: () => {}})
            item.status = canceled
          })
          .catch($showModalWithErrorMsg.bind(this))
      },
      ...mapMutations('ui', [SHOW_MODAL])
    }
  }
</script>
<style scoped>
  .link + .link:before {
    display: inline-block;
    content: '/';
    margin: 0 3px;
  }
</style>
